export default "__VITE_ASSET__CPmExom1__"